import type { ChangeEventHandler } from 'react';

export interface SwitchProps {
  label?: string;
  checked: boolean;
  onChange?: ChangeEventHandler<HTMLInputElement>;
  disabled?: boolean;
}

export function Switch({ label, checked, onChange, disabled }: SwitchProps) {
  return (
    <label className="tr-switch">
      <input type="checkbox" checked={checked} onChange={onChange} disabled={disabled} />
      <span className="tr-switch__track" />
      {label && <span>{label}</span>}
    </label>
  );
}
